import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import "default-passive-events"; //去除touchstart谷歌提示
import "@/utils/format.js"; //时间格式化
import '@/styles/common.scss' // 公共样式
import Viewer from "v-viewer";
// import "viewerjs/dist/viewer.css";
import scroll from "vue-seamless-scroll";
// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// flexible
import "@/utils/flexible.js";
import Vant, {
  Lazyload
} from "vant";
import "vant/lib/index.css";
import '@/router/beforeEach'
import pageWxShare from "./mixins/pageWxShare";
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueAwesomeSwiper);

Vue.use(scroll);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.mixin(pageWxShare);
new Vue({
  router,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");